/** @jsx jsx */
import { jsx } from '@emotion/core'
// import cmsUtils from '../../cmsUtils';
import utils from 'utils'
import { ShareButtons } from 'site/shareButtons/shareButtons'

export function SharingIcons(props) {
  const item = props.item;
  const cmsOption = props.cmsOption || {};
  //console.log(cmsOption)
  //console.log('item', item);

  const cssClass = utils.classNames('cms_item', item.cssClass || item.anchorName || '');
  const shareUrl = utils.site.fullUrl(window.location.pathname + window.location.search)
  
  // Get selected platforms from item configuration
  const selectedPlatforms = item.selectedSocialPlatforms ? 
    item.selectedSocialPlatforms.split(',').map(p => p.trim()) : 
    ['facebook', 'whatsapp', 'email']
  
  const shareLabel = item.shareButtonLabel || 'SHARE THIS PAGE:'
  const buttonPosition = item.buttonPosition || 'center'

  return <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
    <ShareButtons 
      shareUrl={shareUrl} 
      pageTitle={document.title}
      topLabel={shareLabel}
      selectedPlatforms={selectedPlatforms}
      buttonPosition={buttonPosition}
    />
  </div>
}
